import { PrestamoReadingDtoProps } from "./DTOs/PrestamoReadingDto"

export const adapterPrestamoById = (
  prestamo: PrestamoReadingDtoProps
): PrestamoReadingDtoProps => {
  return {
    camposPersonalizados: prestamo?.camposPersonalizados,
    comisiones: prestamo?.comisiones,
    concepto: prestamo?.concepto,
    contactoId: prestamo?.contactoId,
    cuentaBancariaId: prestamo?.cuentaBancariaId,
    cuentaContable: prestamo?.cuentaContable,
    cuentaContableEmpresaId: prestamo?.cuentaContableEmpresaId,
    descripcion: prestamo?.descripcion,
    deuda: prestamo?.deuda,
    duracion: prestamo?.duracion,
    empresaId: prestamo?.empresaId,
    estado: prestamo?.estado,
    fecha: prestamo?.fecha,
    identificador: prestamo?.identificador,
    importe: prestamo?.importe,
    importeAmortizacion: prestamo?.importeAmortizacion,
    importePendiente: prestamo?.importePendiente,
    interes: prestamo?.interes,
    periodoAmortizacion: prestamo?.periodoAmortizacion,
    razonSocial: prestamo?.razonSocial,
    tipoImporteAmortizacion: prestamo?.tipoImporteAmortizacion,
    tipoPrestamo: prestamo?.tipoPrestamo,
    totalAmortizado: prestamo?.totalAmortizado,
  }
}
